import React from 'react';
import SurveyListLoader from './parts/SurveyListLoader';
import SurveyTable from './parts/SurveyTable';

function SurveyList() {
  return (
    <SurveyListLoader>
      <SurveyTable />
    </SurveyListLoader>
  );
}

export default SurveyList;
